import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { PhoneInput } from '@telialt/common-phone-input/src';
import { useUserData } from '@telialt/utils/src/SSO/useUserData';

import { LEAD_TEST_IDS } from '../constants';
import { LeadFieldName } from '../model';

//  Pattern: starts with +370 or 0, followed by 3, 4, 5, 6, followed by 7 digits.
const PHONE_VALIDATION_PATTERN = /^((0|\+370)[3456]\d{7})?$/.source;

type Props = { initialValue?: string; isPrefilled?: boolean };

export const PhoneField: FC<Props> = ({ initialValue, isPrefilled }) => {
    const { t } = useTranslations();
    const { userData } = useUserData();

    return (
        <PhoneInput
            required={true}
            pattern={PHONE_VALIDATION_PATTERN}
            label={t['content.lead.phone_or_mobile.label']}
            helperText={t['content.lead.phone_or_mobile.help_text']}
            name={'phoneNumber' as LeadFieldName}
            dataTest={LEAD_TEST_IDS.FIELD_PHONE}
            defaultValue={initialValue || (isPrefilled && userData?.contactNumber) || ''}
        />
    );
};
